import { useEffect, useRef, useState } from 'react';
import Carousel from '../carousel/Carousel';
import './detailsImageDisplay.css';
import { ReactComponent as Arrow } from '../../assets/icons/trvto_arrowRightWhite.svg';

function DetailsImageDisplay({ imageData, videoData, stayImages }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const thumbnailRefs = useRef([]);

    const smallImgRef = useRef(null);

    // Slot the stay photos into the gallery right after the first 2 main images,
    // then the rest of the main images.
    const base = Array.isArray(imageData) ? imageData : [];
    const stay = (Array.isArray(stayImages) ? stayImages : []).filter(Boolean);
    const mergedImages = stay.length ? [...base.slice(0, 2), ...stay, ...base.slice(2)] : base;

    useEffect(() => {
        const el = smallImgRef.current;
        if (!el) return;

        const scrollToCenter = () => {
            const scrollWidth = el.scrollWidth;
            const clientWidth = el.clientWidth;

            if (scrollWidth > clientWidth) {
                el.scrollLeft = (scrollWidth - clientWidth) / 2;
            }
        };

        scrollToCenter();
    }, [mergedImages]); // your images array

    const prevImage = () => {
        setCurrentIndex((prev) => (prev === 0 ? mergedImages.length - 1 : prev - 1));
    };

    const nextImage = () => {
        setCurrentIndex((prev) => (prev === mergedImages.length - 1 ? 0 : prev + 1));
    };

    useEffect(() => {
        if (thumbnailRefs.current[currentIndex]) {
            thumbnailRefs.current[currentIndex].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest', // prevents vertical page scroll
                inline: 'center'
            });
        }
    }, [currentIndex]);

    return (
        <div className='tripDetailsDivUser'>
            {/* MAIN IMAGE */}
            <div className='tripMainImg'>
                {/* <button type='button' className='arrow left' onClick={prevImage}>
                    <span>‹</span>
                </button> */}
                <div onClick={prevImage} className={`arrowBttn left`}>
                    <span>‹</span>
                </div>
                <img src={mergedImages[currentIndex]} alt='main' className='mainImg' />

                <div onClick={nextImage} className={`arrowBttn right`}>
                    <span>›</span>
                </div>

                {/* DOTS */}
                <div className='dots'>
                    {mergedImages.map((_, index) => (
                        <span key={index} className={`dotImg ${index === currentIndex ? 'activeDot' : ''}`} />
                    ))}
                </div>
            </div>

            {/* THUMBNAILS */}
            <div className='tripSmallImg' ref={smallImgRef}>
                {mergedImages.map((img, index) => (
                    <img
                        key={index}
                        ref={(el) => (thumbnailRefs.current[index] = el)}
                        src={img}
                        alt='thumb'
                        className={`smallImg ${index === currentIndex ? 'activeThumb' : ''}`}
                        onClick={() => setCurrentIndex(index)}
                    />
                ))}
            </div>
        </div>
    );
}

export default DetailsImageDisplay;
